export default "__VITE_ASSET__yhjZqsDO__"